module.exports = __webpack_public_path__ + "media/images/front/pc/institution-search/balloon-c42ffeeb1a98870e8cb7b1c4e9494898.png";